import React from 'react';
import ServerPaginatedTable from '../utils/pagination.server';
import moment from 'moment';
// import { table, th, thead, tr, td } from 'reactable';
// import PdfIcon from 'react-icons/lib/md/picture-as-pdf'
import ExcelIcon from 'react-icons/lib/md/insert-drive-file';
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import { commonConstants} from "../../_constants";
import { appHelpers } from '../../_helpers';
import './style.css';
import {
    Card, CardBody, CardGroup
} from 'reactstrap';

 function formatAmount(amount){
     if(amount===null){
         return 0.00
     }
     else{
         return appHelpers.numberWithCommas(amount)
     }
}
function formatDate(date){
     if (date===null){
         return ''
     }
     else{
         return moment(date).format('MMM Do YYYY')
     }
}


const Aggregate =({data,downloadFile})=>(
        <div>
                <CardGroup className="sales-card mb-3">
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody  className="justify-content-between fit">
                            <h6 className="text-uppercase title font-weight-bold small">Total Payment</h6>
                            <h6 className="font-weight-normal mb-0"><span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span> <span fontSize='15px'> {formatAmount(data[0].NGNTotalPaid)} </span> | <span style={{ color: "#00c853", fontSize: "15px"}}> &#x0024; </span> <span fontSize='15px'> {formatAmount(data[0].USDTotalPaid)}</span></h6>
                        </CardBody>
                    </Card>
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody className={'fit'}>
                            <h6 className="text-uppercase title font-weight-bold small">Total Invoiced</h6>
                            <h6 className="font-weight-normal mb-0"><span style={{ color: "#00c853", fontSize: "15px"}}>&#8358; </span><span fontSize="15px"> {formatAmount(data[0].NGNTotalInvoiced)}</span> | <span style={{ color: "#00c853", fontSize: "15px"}}> &#x0024; </span> <span fontSize="15px"> {formatAmount(data[0].USDTotalInvoiced)}</span></h6>
                        </CardBody>
                    </Card>
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody className={'fit'}>
                            <div className="col-sm-12 text-center" style={{marginBottom:'15px'}}>
                                <h6 className="text-uppercase title font-weight-bold small">Download Payment Detailed Report Here: </h6>
                                {/*<span className="pointer" onClick={ () => downloadFile(commonConstants.PDF_DOWNLOAD_TYPE)}>*/}
                                {/*<ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="18" color="#e53335" className="icon-picture-as-pdf"/>} content='Download PDF' id={'downloadPdfIcon'}/>*/}
                                {/*</span>*/}
                                <span className="pointer" onClick={() => downloadFile(commonConstants.EXCEL_DOWNLOAD_TYPE)}>
                                            <ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="18" color="#5ead57" className="icon-insert-drive-file"/>} content='Download Excel' id={'downloadExcelIcon'}/>
                                        </span>
                            </div>
                        </CardBody>
                    </Card>
                </CardGroup>
</div>
)

const DataTable = ({data,downloadFile,converter}) =>{
    return (data[0].Reconciliations.length === 0) ?
        (<PageEmptyContent message='No record match your search!'/>) :
        (
            <div className="view">
                {/*Files to be downloaded*/}
                    <Aggregate data={data} downloadFile={downloadFile}/>

                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>
                            <th column="issuer">
                                <span>Airline [Issuer]</span>
                            </th>
                            <th column="operator" >
                                <span>Airline [Lifting Operator]</span>
                            </th>
                            <th column="location">
                                <span>Location</span>
                            </th>
                            <th column="start">
                                <span>Flight Start Date</span>
                            </th>
                            <th column="end">
                                <span>Flight End Date</span>
                            </th>
                            <th column="invoiceAmount">
                                <span>Invoice Amount</span>
                            </th>
                            <th column="invoiceDate">
                                <span>Invoice Date</span>
                            </th>
                            <th column="invoiceNumber">
                                <span>Invoice Number</span>
                            </th>
                            <th column="currency">
                               Currency
                            </th>
                            <th column="billedAmount">
                                Billed Amount
                            </th>
                            <th column="paymentAmount">
                                Payment Amount
                            </th>
                            <th column="paymentDate">
                                Payment Date
                            </th>
                            <th column="amountDue">
                                Amount Due
                            </th>
                            <th column="paymentStatus">
                                Payment Status
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data[0].Reconciliations.map((record, i) =>
                            <tr key={i}>
                                <td column="issuer" className="text-capitalize">{converter(record.Issuer)}</td>
                                <td column="operator" className="text-capitalize">{converter(record.LiftingOperator)}</td>
                                <td  column="location" className="text-capitalize">{record.AccountCode}</td>
                                <td column="start">{formatDate(record.StartDate)}</td>
                                <td column="end">{formatDate(record.EndDate)}</td>
                                {/*{appHelpers.numberWithCommas(record.NetAmountCurrency)}*/}
                                <td column="invoiceAmount" className="text-capitalize">{formatAmount(record.NetAmountCurrency)}</td>
                                <td column="invoiceDate" >{formatDate(record.InvoiceDate)}</td>
                                <td column="invoiceNumber" className="text-capitalize">{record.InvoiceNumber}</td>
                                <td column="currency" className="text-capitalize">{record.CurrencyString}</td>
                                <td column="billedAmount" className="text-capitalize">{formatAmount(record.BilledAmount)}</td>
                                <td  column="paymentAmount" className="text-capitalize">{formatAmount(record.PaidAmount)}</td>
                                <td  column="paymentDate">{formatDate(record.PaymentDate)}</td>
                                <td column="amountDue" className="text-capitalize">{formatAmount(record.AmountDue)}</td>
                                <td column="paymentStatus"  className="text-capitalize">{record.PaymentStatusString}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
}

export default class PaginatedResult extends React.Component {


    render() {
        const {converter, pageSize, currentPage, totalCount,navigate, paymentResults,downloadFile} = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4">
                        <ServerPaginatedTable currentPage={currentPage} fetchMore={navigate} target={<DataTable data={paymentResults} downloadFile={downloadFile} converter={converter} />} pageSize={pageSize} totalCount={totalCount }/>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/payment-reconciliation/pr-result.js